import { useEffect, useState } from "react";
import { onValue } from "firebase/database";
import { deleteObject, listAll, ref as storageRef, uploadString } from "firebase/storage";
import { firebaseStorage } from "../firebase";
import { svgToString } from "./helper";

function _deleteFirebaseElement(url) {
    let ref = null;
    try {
        // Nell'SDK modulare ref() accetta direttamente un download URL o un gs://
        ref = storageRef(firebaseStorage, url)
    } catch (e) {
        console.log(e, 'ERROR Remove ' + url);
    }
    if (ref) {
        deleteObject(ref)
            .then(() => {
                console.log('removed ' + url);
            })
            .catch(() => {
                console.log('ERROR Remove ' + url);
            });
    }
}

/**
 * elimina tutte le immagini nella lista da firebase
 * @param list vettore di stringa con gli url delle immagini da eliminare
 */
export function removeImagesFirebase(list) {

    if (!list)
        return

    list.forEach(url => {
        _deleteFirebaseElement(url)
    });
}

export function useSynchronizedData(firebaseRef, deps = []) {

    const [data, setData] = useState([])

    useEffect(() => {
        // onValue restituisce la funzione di unsubscribe: e' il cleanup dell'effetto
        return onValue(firebaseRef, querySnapShot => {
            let newData = [];
            if (querySnapShot.val()) {
                Object.entries(querySnapShot.val()).forEach(([key, value]) => {
                    newData.push({ key, ...value });
                });
            }
            setData(newData);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return [data, setData]
}

export async function saveIconFirebase(mui, icon) {
    let dir = storageRef(firebaseStorage, '/achievement icons');
    let res = null;
    try {
        res = await listAll(dir);
    } catch (e) {
        console.log('Error List All', e);
        return false
    }
    let save = true;
    res.items.forEach((itemRef) => {
        if (itemRef.name.replace('.svg', '') === icon)
            save = false
    });
    //controlla che il file non esista gia, se non esiste caricalo
    if (save) {
        try {
            await uploadString(storageRef(firebaseStorage, `/achievement icons/${icon}.svg`), svgToString(mui[icon]))
        } catch (e) {
            console.log('Error uploading svg', e);
            return false
        }
        console.log('salvato');
    }
    return true;
}
